import React from 'react';
import { Table } from 'react-bootstrap';
import { useSelector } from 'react-redux';

const OverheadCraneTable = ({ activeLane }) => {
  // Get data from Redux store
  const data = useSelector(state => state.overheadCrane?.data || []);
  const isLoading = useSelector(state => state.overheadCrane?.loading || false);

  // Debug logging
  console.log('OverheadCraneTable - data:', data);
  console.log('OverheadCraneTable - isLoading:', isLoading);

  const filteredData = activeLane === 'ALL' ? data : data.filter(item => item.lane === activeLane);

  if (isLoading) {
    return <div className="text-center p-4">Loading...</div>;
  }

  if (!data || data.length === 0) {
    return <div className="text-center p-4">No data available</div>;
  }

  return (
    <div className="table-responsive">
      <Table className="table">
        <thead>
          <tr>
            <th>Asset Number</th>
            <th>Name</th>
            <th>Capacity</th>
            <th>Cell Number</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredData.map(overheadCrane => (
            <tr key={overheadCrane.id}>
              <td>{overheadCrane.assetNumber || '--'}</td>
              <td>{overheadCrane.brand || '--'}</td>
              <td>{overheadCrane.tonnage || '--'}</td>
              <td>{overheadCrane.cellNumber || '--'}</td>
              <td>
                <span className="badge bg-success">Active</span>
              </td>
              <td>
                <button
                  className="btn btn-sm btn-outline-primary"
                  onClick={() => alert('Edit functionality will be implemented here')}
                >
                  Edit
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default OverheadCraneTable;
